export default __webpack_public_path__ + "static/media/Watch.b724d0ac.jpg";